import React from 'react'

import Container from '@mui/material/Container'
import Box from '@mui/material/Box'

const RegistrationStep = props => {
  const { children } = props

  return (
    <Container maxWidth='md'>
      <Box mt={[4, 2]} mb={[4, 6]}>
        {children}
      </Box>
    </Container>
  )
}

export default RegistrationStep
